import { NrlSide } from "@vega-api/generated/types/nrlSide";
import { m } from "@vega-core/paraglide/messages";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

type NrlSideToggleProps = {
  value: NrlSide;
  onChange: (side: NrlSide) => void;
  disabled?: boolean;
};

const sideOptions = [
  { id: NrlSide.LP, label: m.coInvestments_nrl_side_lp() },
  { id: NrlSide.PROVIDER, label: m.coInvestments_nrl_side_provider() },
];

// Compact two-state toggle matching the design's small pill — SegmentedTabs'
// smallest size (h-40px) is too tall for the dense NRL row.
export const NrlSideToggle = ({
  value,
  onChange,
  disabled,
}: NrlSideToggleProps) => (
  <div
    className="flex shrink-0 items-center gap-0.5 rounded-default bg-background/component p-0.5"
    role="group"
  >
    {sideOptions.map((option) => {
      const isActive = option.id === value;

      return (
        <button
          aria-pressed={isActive}
          className={cnTwMerge(
            "rounded-default px-2 py-0.5 body-small-medium text-text/secondary transition-colors focus-outline-themed",
            isActive && "bg-background/primary text-text/primary shadow-card",
            disabled && "cursor-not-allowed opacity-50",
          )}
          disabled={disabled || isActive}
          key={option.id}
          onClick={() => onChange(option.id)}
          type="button"
        >
          {option.label}
        </button>
      );
    })}
  </div>
);
